import { BaseModel } from './base.model';

export interface Technology {
    id: number;
    name: string;
    frameworkVersion: string;
    // 1c: slug normalizado, calculado por backend, mostrado readonly en form.
    nameSlug?: string;
}

export class Technology implements BaseModel {
  id: number;
  name: string;
  frameworkVersion: string;
  nameSlug?: string;

  constructor();
  constructor(id: number, name: string, frameworkVersion: string);

  constructor(id?: number, name?: string, frameworkVersion?: string) {
    if (id !== undefined) {
      this.id = id;
    }

    if (name !== undefined) {
      this.name = name;
    } else {
      this.name = '';
    }

    if (frameworkVersion !== undefined) {
      this.frameworkVersion = frameworkVersion;
    } else {
      this.frameworkVersion = '';
    }
  }

  getApiName(): string {
    return 'technology';
  }

  getName(): string {
    return 'Tecnología';
  }

  getNamePl(): string {
    return 'Tecnologías';
  }
}